export default __webpack_public_path__ + "static/media/vehicle-icon-nav-completed.e594c7c0.svg";